import React from 'react';
import parse from 'html-react-parser';

import Heading from '../../../common/Heading/head';
import SubHeading from '../../../common/Heading/subhead';
import { ConstantText, getAddressHeader } from '../constant';
import { Row, Col, Grid } from '../../../common/Grid';

const Header = () => {
  const subHeadingValue = getAddressHeader();
  return (
    <Grid>
      <Row className="marginTop24 marginBottom32">
        <Col colSizes={{ mobile: 4, tablet: 8, desktop: 8 }}>
          <Heading heading={ConstantText.header} primitive="h1" bold />
        </Col>
      </Row>
      <Row>
        <Col colSizes={{ mobile: 4, tablet: 12, desktop: 4 }}>
          <SubHeading subHeading={parse(subHeadingValue || '')} primitive="p" />
        </Col>
      </Row>
    </Grid>
  );
};

export default Header;
